import './HostSection.css';
import React  from "react"
import { Link } from 'react-router-dom';
import { Card, Button, OverlayTrigger, Tooltip} from 'react-bootstrap';
import RatingStars from "./RatingStars";
import ScheduleButton from "./ScheduleButton"
import trackingCall from 'utils/trackingCall';
import LazyLoad from 'react-lazyload';
import ueIcon from '../assets/UElogo_whiteback.png'
import publicIcon from '../assets/public-icon-16.jpg'

const HostSection = (
    {userId, firstName, lastName, availableToPublic, photoLink, headline, hostMessage, resumeLink, averageRating,
     hostedGameCount, hostTimezone, emailId, phoneNumber, videoLink, calendarLink,
     paymentLink}
    ) => {

        let alt = firstName + ' ' + lastName + ' photo';
        const starSize = 25 //sizing parm for Rating Stars (size can't be handeled with

        const starsTooltip = "Review " + firstName + "'s ratings"

        const renderTooltip = (tip) => (
            <Tooltip id="button-tooltip">
              {tip}
            </Tooltip>
          );

        return (
            <Card className = "host-card" style={{ width: '28rem' }}>
            <LazyLoad height="100%" offset={100} once>
                <Card.Img variant="top" className="host-photo" src={photoLink} alt={alt}/>
             </LazyLoad>
                <Card.Body>
                    <Card.Title className="host-name"> {firstName} {lastName}</Card.Title>
                    <Card.Subtitle className="headline">{headline}</Card.Subtitle>
                    <Link to={
                            {key: 'hostratingdetail',
                            pathname: '/hostratingdetail',
                            userId: userId,
                            emailId: emailId,
                            firstName: firstName,
                            lastName: lastName,
                            headline: headline,
                            photoLink: photoLink,
                            calendarLink: calendarLink,
                            averageRating: averageRating,
                            hostedGameCount: hostedGameCount,
                            availableToPublic: availableToPublic
                            }
                            }>
                            <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip(starsTooltip)}
                            >
                            <button className="trans-button"
                            onClick={() => {
                                    trackingCall('Rating Stars ' + firstName + ' ' +lastName)}}
                                    >
                            <RatingStars
                                averageRating = {averageRating}
                                starSize = {starSize}
                            />
                            </button>
                            </OverlayTrigger>
                    </Link>
                    <Card.Text>
                        Number of games hosted:  {hostedGameCount}
                    </Card.Text>
                    <Card.Text>
                        Timezone(s): {hostTimezone}
                    </Card.Text>
                    <Card.Text>
                    {(availableToPublic === 'y' || availableToPublic === 'Y') &&
                        <>  Available to General Public {' '}
                        <img className="public-icon" src={publicIcon} alt={"Public Logo"}/>
                        </>
                    }
                    {(availableToPublic !== 'y' && availableToPublic !== 'Y') &&
                        <>  Exclusively for Utopia Experiences Clients {' '}
                        <img className="ue-icon" src={ueIcon} alt={"UE Logo"}/>
                        </>
                    }
                    </Card.Text>
                    </Card.Body>
                    <Card.Footer className="card-footer">
                    <Link to={
                        {key: 'moreabout',
                        pathname: '/moreabouthost',
                        emailId: emailId,
                        firstName: firstName,
                        lastName: lastName,
                        headline: headline,
                        photoLink: photoLink,
                        calendarLink: calendarLink,
                        availableToPublic: availableToPublic
                    }
                    }>
                    <Button
                        className="blue-button">Learn more about {firstName}</Button>
                    </Link>
                    <ScheduleButton firstName = {firstName}
                                photoLink = {photoLink}
                                calendarLink={calendarLink}
                                availableToPublic={availableToPublic}
                    />
                    </Card.Footer>
            </Card>



        )


}

export default HostSection